export const CssModulesClassName = (styleName = '', stylesObject = {}) => {
    const arr = styleName.split(' ');

    return arr.map(name => {
        return stylesObject[name];
    });
};
